import {
  NewsItemSmallImage,
  NewsItemWide,
  NewsItemBigImage,
  NewsItemBigText,
  NewsItemGalleryWide,
  NewsItemObjectImages,
} from '#components';
import type { Component } from 'vue';
import type { TSpecialProjectExtraId } from '~/shared/api/client/publisher/publisher.dto';

export const publicators = {
  one_line: defineAsyncComponent(
    () => import('~/entities/one-line/ui/OneLine.vue'),
  ),
  stories: defineAsyncComponent(
    () => import('~/entities/stories/ui/Stories.vue'),
  ),
  video: defineAsyncComponent(
    () => import('~/entities/main-videos/ui/MainVideos.vue'),
  ),
  photos: defineAsyncComponent(
    () => import('~/entities/main-photos/ui/MainPhotos.vue'),
  ),
  expert_opinions: defineAsyncComponent(
    () => import('~/entities/expert-opinions/ui/ExpertOpinions.vue'),
  ),
  special_project_chronicles: defineAsyncComponent(
    () =>
      import(
        '~/entities/special-project-chronicles/ui/SpecialProjectChronicles.vue'
      ),
  ),
  special_project_chronicles_year: defineAsyncComponent(
    () =>
      import(
        '~/entities/special-project-chronicles-year/ui/SpecialProjectChroniclesYear.vue'
      ),
  ),
  retail_magazine: defineAsyncComponent(
    () => import('~/entities/retail-magazine/ui/RetailMagazine.vue'), // Афиша Мероприятия
  ),
  warehouse_magazine: defineAsyncComponent(
    () => import('~/entities/warehouse-magazine/ui/WarehouseMagazine.vue'), // Журнал CRE
  ),
  number_day: defineAsyncComponent(
    () => import('~/entities/number-day/ui/NumberDay.vue'),
  ),
  tripple_news: defineAsyncComponent(
    () => import('~/entities/tripple-news/ui/TrippleNews.vue'),
  ),
  special_pik: defineAsyncComponent(
    () => import('~/entities/special-pik/ui/SpecialPik.vue'),
  ),
  subscribe: defineAsyncComponent(
    () => import('~/entities/subscribe/ui/Subscribe.vue'),
  ),
  // Этих компонентов ниже еще нет на бэке, назвал произвольно, потом очевидно понадобится переименование
  slider_affiche: defineAsyncComponent(
    () => import('~/entities/slider-affiche/ui/SliderAffiche.vue'),
  ),
  cre_awards: defineAsyncComponent(
    () => import('~/entities/cre-awards/ui/CreAwards.vue'),
  ),
  chronicle_banner1: defineAsyncComponent(
    () => import('~/entities/chronicle_banners/ui/ChronicleBanner1.vue'),
  ),
  chronicle_banner2: defineAsyncComponent(
    () => import('~/entities/chronicle_banners/ui/ChronicleBanner2.vue'),
  ),
  chronicle_banner3: defineAsyncComponent(
    () => import('~/entities/chronicle_banners/ui/ChronicleBanner3.vue'),
  ),
  chronicle_banner4: defineAsyncComponent(
    () => import('~/entities/chronicle_banners/ui/ChronicleBanner4.vue'),
  ),
};

/* Блоки публикатора special_project_extra, id блока приходит в text_one_block */
export const specialProjectExtras: Record<TSpecialProjectExtraId, Component> = {
  cmwp: defineAsyncComponent(
    () =>
      import('~/entities/special-project-extra/ui/cmwp/SpecialProjectCmwp.vue'),
  ),
  cre35: defineAsyncComponent(
    () =>
      import(
        '~/entities/special-project-extra/ui/cre35/SpecialProjectCre35.vue'
      ),
  ),
  cre35_teaser: defineAsyncComponent(
    () =>
      import(
        '~/entities/special-project-extra/ui/cre35-teaser/SpecialProjectCre35Teaser.vue'
      ),
  ),
};

export const isSpecialProjectExtraId = (
  value?: string | null,
): value is TSpecialProjectExtraId =>
  Boolean(value && value in specialProjectExtras);

export const newsTypes = {
  image_right_single: NewsItemSmallImage,
  image_left_big: NewsItemWide,
  title_big: NewsItemBigText,
  background_giant: NewsItemBigImage,
  gallery_wide: NewsItemGalleryWide,
  object_images: NewsItemObjectImages,
};
